import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics'

import { getPlatformConfig } from './sso-utils'

const runHaptic = async (action: () => Promise<void>, errorMsg: string) => {
  const { platform } = getPlatformConfig()
  const isWeb = platform === 'web'
  const isAndroid = platform === 'android'

  if (isWeb || isAndroid) {
    return
  }

  try {
    await action()
  } catch (error) {
    console.error(errorMsg, error)
  }
}

export function createHaptics() {
  return {
    light: () =>
      runHaptic(
        () => Haptics.impact({ style: ImpactStyle.Light }),
        'Haptics impact light not supported:'
      ),
    medium: () =>
      runHaptic(
        () => Haptics.impact({ style: ImpactStyle.Medium }),
        'Haptics impact medium not supported:'
      ),
    vibrate: () =>
      runHaptic(() => Haptics.vibrate(), 'Haptics vibrate not supported:'),
    selectionStart: () =>
      runHaptic(
        () => Haptics.selectionStart(),
        'Haptics selection start not supported:'
      ),
    selectionChanged: () =>
      runHaptic(
        () => Haptics.selectionChanged(),
        'Haptics selection changed not supported:'
      ),
    selectionEnd: () =>
      runHaptic(
        () => Haptics.selectionEnd(),
        'Haptics selection end not supported:'
      ),
    notificationSuccess: () =>
      runHaptic(
        () => Haptics.notification({ type: NotificationType.Success }),
        'Haptics notification success not supported:'
      ),
    notificationWarning: () =>
      runHaptic(
        () => Haptics.notification({ type: NotificationType.Warning }),
        'Haptics notification warning not supported:'
      ),
    notificationError: () =>
      runHaptic(
        () => Haptics.notification({ type: NotificationType.Error }),
        'Haptics notification error not supported:'
      )
  }
}

export default createHaptics()
